// Custom JS - cta-scroll-to-anchor.js

const CTAScrollToAnchor = {
  button: null,
  target: null,
  offset: 0,
  header: null,

  /**
   * Inizializza il modulo con l'ID del pulsante, dell'ancora e opzionale header
   * @param {string} buttonId - ID del pulsante
   * @param {string} targetId - ID dell'ancora
   * @param {string} headerId - ID del header (default null)
   */
  initialize(buttonId, targetId, headerId = null) {
    this.button = document.getElementById(buttonId);
    this.target = document.getElementById(targetId);
    this.header = headerId ? document.getElementById(headerId) : null;

    if (!this.button) {
      console.warn(
        `Pulsante con ID "${buttonId}" non trovato. Probabilmente non è usato in questa pagina.`
      );
      return;
    }

    if (!this.target) {
      console.warn(`Ancora con ID "${targetId}" non trovata.`);
      return;
    }

    this.updateOffset();
    this.attachClickListener();
    this.attachResizeListener();
  },

  /**
   * Aggiorna l'offset in base all'altezza dell'header
   */
  updateOffset() {
    this.offset = this.header ? this.header.offsetHeight : 0;
  },

  /**
   * Calcola la posizione della destinazione con offset
   * @returns {number} La posizione Y della destinazione
   */
  calculateScrollPosition() {
    const targetPosition =
      this.target.getBoundingClientRect().top + window.scrollY;
    return targetPosition - this.offset;
  },

  /**
   * Scroll fluido verso la posizione calcolata
   */
  scrollToPosition() {
    const scrollPosition = this.calculateScrollPosition();

    window.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  },

  /**
   * Listener per il click sul pulsante
   */
  attachClickListener() {
    this.button.addEventListener("click", (event) => {
      event.preventDefault();
      this.scrollToPosition();
    });
  },

  /**
   * Listener per il resize della finestra
   */
  attachResizeListener() {
    window.addEventListener("resize", () => {
      this.updateOffset();
    });
  },
};

export default CTAScrollToAnchor;
